import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from './MessagesList.module.scss';

function EmptyMessagesList() {
  const { t } = useTranslation();

  return (
    <div className={scss.emptyWrapper}>
      <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.emptyIcon} />
      {t('noData')}
    </div>
  );
}

export default EmptyMessagesList;
